import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { getVegNonVegItemImg } from "src/app/shared/utils/menu-cart-item-functions";

@Component({
  selector: "app-menu-description",
  templateUrl: "./menu-description.component.html",
  styleUrls: ["./menu-description.component.scss"],
})
export class MenuDescriptionComponent implements OnInit {
  @Input() modalObj;
  quantity = 1

  constructor(public activeModal: NgbActiveModal,) { }

  ngOnInit() { 
    console.log(this.modalObj)
  }

  itemDecrease() {
    if (this.quantity > 1) {
      this.quantity -= 1;

    }
  }
  itemIncrease() {
    this.quantity += 1
  }

  getVegNonVegImg(isVeg, containsEgg) {
    return getVegNonVegItemImg(isVeg, containsEgg);
  }
}
